/**
 * Los 403 de scope (operador externo fuera de su alcance) traen un mensaje
 * puntual del backend. Devuelve ese mensaje, o null si el error no es uno de
 * estos casos, para que el caller decida el fallback con su propio helper de
 * error (getErrorMessage, mapAddShippingsError, etc.) sin tocarlos.
 */

export function getScopeErrorMessage(error: unknown): string | null {
  const err = error as { status?: number; data?: { message?: string } };
  if (err?.status === 403 && err.data?.message) {
    return err.data.message;
  }
  return null;
}
